"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.winnerHighLowSplitDefault = exports.winnerHighLowSplit = exports.winnerLowOnlyDefault = exports.winnerLowOnly = exports.winnerHighOnlyDefault = exports.winnerHighOnly = exports.wildcardCenterCard = exports.wildcardOneEyedJacks = exports.wildcardDeuces = exports.wildcardLowHoleWithBuy = exports.wildcardLowHole = exports.wildcardQueensAndFollowersDefault = exports.wildcardQueensAndFollowers = exports.wildcardNoneDefault = exports.wildcardNone = exports.optionBuyLastCardUpDefault = exports.optionBuyLastCardUp = exports.optionRollYourOwnAlwaysDefault = exports.optionRollYourOwnAlways = exports.optionRollYourOwnDefault = exports.optionRollYourOwn = exports.optionNoneDefault = exports.optionNone = void 0;
/**
 * defaultOptions.ts
 *
 * This file in houses all the default options ie. (value, description, default?, tooltip?) based on GameOptionsInterface
 * The options here are related to option, wildcard and winner and information related to version goes in respective Game's Options file within this directory
 */
const BuyLastCardUpSetting_1 = require("../enums/BuyLastCardUpSetting");
const HighLowSetting_1 = require("../enums/HighLowSetting");
const RollYourOwnSetting_1 = require("../enums/RollYourOwnSetting");
const WildcardOption_1 = require("../enums/WildcardOption");
exports.optionNone = {
    description: "None",
    value: RollYourOwnSetting_1.RollYourOwnSetting.DISABLED,
};
exports.optionNoneDefault = Object.assign(Object.assign({}, exports.optionNone), { default: true });
exports.optionRollYourOwn = {
    description: "Roll Your Own",
    value: RollYourOwnSetting_1.RollYourOwnSetting.FIRST,
    tooltip: "Players selects which card to turn up after initial cards are dealt.",
};
exports.optionRollYourOwnDefault = Object.assign(Object.assign({}, exports.optionRollYourOwn), { default: true });
exports.optionRollYourOwnAlways = {
    description: "Roll Your Own (Always)",
    value: RollYourOwnSetting_1.RollYourOwnSetting.ALWAYS,
};
exports.optionRollYourOwnAlwaysDefault = Object.assign(Object.assign({}, exports.optionRollYourOwnAlways), { default: true });
exports.optionBuyLastCardUp = {
    description: "Buy Last Card Up",
    value: BuyLastCardUpSetting_1.BuyLastCardUpSetting.ENABLED,
};
exports.optionBuyLastCardUpDefault = Object.assign(Object.assign({}, exports.optionBuyLastCardUp), { default: true });
exports.wildcardNone = {
    description: "None",
    value: WildcardOption_1.WildcardOption.NONE,
};
exports.wildcardNoneDefault = Object.assign(Object.assign({}, exports.wildcardNone), { default: true });
exports.wildcardQueensAndFollowers = {
    description: "Queens and Followers",
    value: WildcardOption_1.WildcardOption.QUEENS_AND_FOLLOWERS,
};
exports.wildcardQueensAndFollowersDefault = Object.assign(Object.assign({}, exports.wildcardQueensAndFollowers), { default: true });
exports.wildcardLowHole = {
    description: "Low Hole",
    value: WildcardOption_1.WildcardOption.LOW_HOLE,
    tooltip: "Each player's lowest hole card is wild for them, as well as any cards of matching value within their hand and community cards. Players have option to buy their last card up for 2X min bet.",
};
exports.wildcardLowHoleWithBuy = Object.assign(Object.assign({}, exports.wildcardLowHole), { value: WildcardOption_1.WildcardOption.LOW_HOLE_WITH_BUY });
exports.wildcardDeuces = {
    description: "Deuces",
    value: WildcardOption_1.WildcardOption.DEUCES,
};
exports.wildcardOneEyedJacks = {
    description: "One Eyed Jacks",
    value: WildcardOption_1.WildcardOption.ONE_EYED_JACKS,
};
exports.wildcardCenterCard = {
    description: "Center Card",
    value: WildcardOption_1.WildcardOption.CENTER_CARD,
    tooltip: "The center card of the the community cards is wild for everybody, as well as any cards of matching value within the community cards and players' hands.",
};
exports.winnerHighOnly = {
    description: "High Only",
    value: HighLowSetting_1.HighLowSetting.HIGH,
    tooltip: "Highest ranking poker hand wins the pot.",
};
exports.winnerHighOnlyDefault = Object.assign(Object.assign({}, exports.winnerHighOnly), { default: true });
exports.winnerLowOnly = {
    description: "Low Only",
    value: HighLowSetting_1.HighLowSetting.LOW,
    tooltip: "Lowest ranking poker hand wins the pot.",
};
exports.winnerLowOnlyDefault = Object.assign(Object.assign({}, exports.winnerLowOnly), { default: true });
exports.winnerHighLowSplit = {
    description: "High-Low Split",
    value: HighLowSetting_1.HighLowSetting.HI_LO,
    tooltip: 'High hand splits the pot with low hand. At showdown, players declare if their hand is to be evaluated as "High" or "Low" or "Both."',
};
exports.winnerHighLowSplitDefault = Object.assign(Object.assign({}, exports.winnerHighLowSplit), { default: true });
//# sourceMappingURL=defaultOptions.js.map